import { supabase } from "@/integrations/supabase/client";

export type SubscriptionTier = 'free' | 'family_premium' | 'school_partner';

export const checkPremiumAccess = async (userId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('subscription_tier')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Error checking subscription:', error);
      return false;
    }

    return data?.subscription_tier === 'family_premium' || data?.subscription_tier === 'school_partner';
  } catch (error) {
    console.error('Error in checkPremiumAccess:', error);
    return false;
  }
};

export const getSubscriptionTier = async (userId: string): Promise<SubscriptionTier> => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('subscription_tier')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Error getting subscription tier:', error);
      return 'free';
    }

    return (data?.subscription_tier as SubscriptionTier) || 'free';
  } catch (error) {
    console.error('Error in getSubscriptionTier:', error);
    return 'free';
  }
};

export const canAddChildren = async (userId: string, currentChildCount: number): Promise<boolean> => {
  const tier = await getSubscriptionTier(userId);
  
  if (tier === 'free') return currentChildCount < 1;
  if (tier === 'family_premium') return currentChildCount < 3;
  if (tier === 'school_partner') return true; // unlimited
  
  return false;
};
